import { render } from "./group_create.vue?vue&type=template&id=7d73b654&scoped=true"
import script from "./group_create.vue?vue&type=script&lang=js"
export * from "./group_create.vue?vue&type=script&lang=js"

import "./group_create.vue?vue&type=style&index=0&id=7d73b654&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d73b654"]])

export default __exports__